import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    beautyPerfect: {
        width: '90%',
        borderTopRightRadius: '250px',
        borderBottomRightRadius: '250px',
        border: '2px solid #d8abc6',
        borderLeft: 'none',
        transition: '100ms box-shadow linear',

        '&:hover' : {
            boxShadow: '1px 1px 25px #dadada'
        },

        '& .title' : {
            display: 'table',
            borderBottom: '1px solid rgba(0,0,0,0.4)',

            [theme.breakpoints.down("xs")]: {
                padding: '50px 10px 10px 20px',
                width: '75%'
            },
            [theme.breakpoints.up("xs")]: {
                padding: '40px 40px 10px 20px',
                width: '70%'
            },
            [theme.breakpoints.up("sm")]: {
                padding: '50px 50px 10px 20px',
                width: '50%'
            },
            [theme.breakpoints.up("md")]: {
                padding: '50px 50px 10px 20px',
                width: '45%',
            },
            [theme.breakpoints.up("lg")]: {
                padding: '50px 50px 10px 20px',
                width: '40%',
            },
            [theme.breakpoints.up("xl")]: {
                padding: '50px 50px 10px 20px',
                width: '33%',
            },
            
            '& h3': {
                color: theme.palette.primary.main,
                fontWeight: '400',
                letterSpacing: '5px',
                textAlign: 'right',
                display: 'table-cell',
                verticalAlign: 'bottom'
            },

            '& h5': {
                color: theme.palette.text.primary,
                fontWeight: '400',
                letterSpacing: '0px',
                paddingLeft: '15px',
                display: 'table-cell',
                verticalAlign: 'bottom'
            }

        },

        '& .description': {
            padding: '100px 10% 125px 10%',

            [theme.breakpoints.down("xs")]: {
                padding: '50px 10% 50px 10%',
            },
            [theme.breakpoints.up("xs")]: {
                padding: '50px 10% 50px 10%',
            },
            [theme.breakpoints.up("sm")]: {
                padding: '70px 10% 95px 10%',
            },
            [theme.breakpoints.up("md")]: {
            },
            [theme.breakpoints.up("lg")]: {
            },

            '& h4': {
                color: theme.palette.text.primary,
                width: '90%',
                fontWeight: 400,
                paddingBottom: '15px',
                letterSpacing: '5px',
            }
        }
    }
}));


export default (props) => {
    const classes = useStyles(props), 
        {beautyPerfect} = props;

    return (
        <div className={classes.beautyPerfect}>
            <div className="title">
                <Typography variant="h3"><b>{beautyPerfect.name}</b></Typography>
                <Typography variant="h5">{beautyPerfect.name_en}</Typography>
            </div>
            <div className="description">
                <Typography variant="h4">{beautyPerfect.desc[0]}</Typography>
                <Typography variant="h4">{beautyPerfect.desc[1]}</Typography>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/client/components/tour/BeautyPerfect.js